import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-delete-data",
    templateUrl: "./delete-data.component.html",
    styleUrls: ["./delete-data.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class DeleteDataComponent implements OnInit {
  constructor(private dialog: MatDialogRef<DeleteDataComponent>,
    private authService: AuthService,
    public translate: TranslateService) {
    this.authService?.selectedlanguage$?.subscribe((l) => {
      if (l) {
        translate.use(l ? l : "en");
      }
    }, err => { return (err) });

  }

  ngOnInit() { }

  cancel() {
    this.dialog.close(false);
  }

  removeData() {
    this.dialog.close(true);
  }
}
